import { Molecule, Wrapper, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import Input from './../input/atoms/Input'
import { SecondaryTextXs } from '../../atoms';

const template = styled.div`
  ${({ theme, displayState }) => {
    return css`
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 280px;
    height: 42px;
    border: 1px solid ${displayState?.currentCount > displayState?.totalCount ? "#FD2020" : "#1DBD6B"};
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 12px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    
    &:hover {
      border: 1px solid ${displayState?.currentCount > displayState?.totalCount ? "#FD2020" : "#1DBD6B"};
    }

    @media only screen and (min-width: 768px) {
      min-width: ${displayState?.minWidth ?? "320px"};
    }
  `}}
`;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: Wrapper(styled.div`display: flex; gap: 5px; flex: 1; white-space: nowrap;`),
      name: "CountWrapper",
      atoms: [
        {
          component: Input,
          name: 'Input',
          displayValue: ({ value }) => value ?? '',
          bindings: ({ value, placeholder }) => ({ value, placeholder}),
        },
        {
          component: SecondaryTextXs,
          name: "Count",
          displayState: ({ currentCount, totalCount }) => ({ color: currentCount > totalCount ? "#FD2020" : "#566F75" }),
          displayValue: ({ currentCount, totalCount }) => `${currentCount}/${totalCount} Characters`,
        },
      ],
    },
  ]
})